const { clearCache, getUserPrefs, updatePrefs } = require('../../util/user_prefs_util.js');

/**
 * A service for loading user preference data if it's available.
 *
 * The user preference data should be loaded on every page inside of a script
 * tag with the ID defined by DATA_ID.
 *
 * @ngInject
 * @deprecated Use the util/user_prefs_util.js instead.
 */
function UserPrefsService($q) {
  return {
    clearCache: clearCache,
    getUserPrefs: function() {
      // Convert native Promise to $q promise for Angular digest cycle integration
      return $q.when(getUserPrefs());
    },
    updatePrefs: function(prefs) {
      return $q.when(updatePrefs(prefs));
    }
  };
}

module.exports = UserPrefsService;
